import styled from 'styled-components'

import COLORS from 'constants/colors'

import { width } from 'components/base/Form/Input/Input/styles'

import { SuggestionProps } from './types'

export const Suggestions = styled.div`
  position: absolute;
  width: ${width}px;
  background-color: ${COLORS.WHITE};
  z-index: 10;
  border-left: solid 1px ${COLORS.BORDERS};
  border-right: solid 1px ${COLORS.BORDERS};
  border-bottom: solid 1px ${COLORS.BORDERS};
`

export const Suggestion = styled.div<SuggestionProps>`
  cursor: pointer;
  padding: 15px;
  background-color: ${(props: SuggestionProps): string =>
    (props.active && COLORS.GREYLIGHT) || COLORS.WHITE};
`
